module.exports = __webpack_public_path__ + "static/img/XA30.4586dc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XA30.png
// module id = jQSw
// module chunks = 2